export default __webpack_public_path__ + "static/media/business-model-navigator.44ed538b.pdf";